
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import planShipmentNomenclatureCreateEditDialog from "@/components/journals/PlanShipmentJournal/PlanShipmentNomenclatureCreateEditDialog.vue";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    parentEditingConfig: { required: false, type: TableEditingConfig },
    updateParentModelCallback: { required: false },
  },
  methods: {
    async refreshParent() {
      if (this.updateParentModelCallback) this.updateParentModelCallback();
    },
  },
  computed: {
    planShipmentNomenclatureCreateEditDialog: function () {
      return planShipmentNomenclatureCreateEditDialog;
    },
  },
  data() {
    return {
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "number",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "VolumeSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
        ],
      },
      editingConfig: new TableEditingConfig({
        allowUpdating: (this.parentEditingConfig as any)?.allowUpdating,
        allowAdding: (this.parentEditingConfig as any)?.allowAdding,
        allowDeleting: (this.parentEditingConfig as any)?.allowDeleting,
        confirmDelete: true,
        allowDataFill: (this.parentEditingConfig as any)?.allowDataFill,
        allowExport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: true,
        allowColumnReordering: true,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDeleteMultipleRows: false,
      }),
      columns: [
        new IntegerColumnConfig({
          dataField: "id",
          caption: "Код",
          readOnly: true,
          editVisible: false,
        }),
        new TextColumnConfig({
          dataField: "name",
          caption: "Наименование",
          validationRules: [requiredRule],
        }),
        new DecimalColumnConfig({
          dataField: "volume",
          caption: "Объем (м³)",
          decimalPoints: 0,
        }),
        new IntegerColumnConfig({
          dataField: "boardLength",
          caption: "Длина доски (мм)",
        }),
        new IntegerColumnConfig({
          dataField: "boardHeight",
          caption: "Толщина доски (мм)",
        }),
        new IntegerColumnConfig({
          dataField: "boardWidth",
          caption: "Ширина доски (мм)",
        }),
      ],
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: true,
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "multiple",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
